import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-danger text-white py-1.5 md:py-2.5 px-3 md:px-4 sticky top-0 z-50 shadow-lg border-b-2 border-black/30 animate-pulse-slow" data-id="element-326">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-327">
        <div className="flex items-center gap-1.5 md:gap-2" data-id="element-328">
          <span className="animate-pulse" data-id="element-329">⏰</span>
          <span className="font-bold uppercase tracking-[1px] hidden md:inline" data-id="element-330">
            ¡ÚLTIMAS HORAS! — LANZAMIENTO CIERRA EN:
          </span>
          <span className="font-bold uppercase tracking-[0.5px] md:hidden text-[10px]" data-id="element-331">
            ¡ÚLTIMAS HORAS!
          </span>
          <span className="font-display font-bold bg-black/40 px-1.5 md:px-2.5 py-0.5 md:py-1 rounded text-[13px] md:text-[18px] tracking-[1px]" data-id="element-332">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="font-bold text-[10px] md:text-base hidden sm:inline" data-id="element-333">
          🔥 Después sube. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-334">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-335">
        <FadeIn data-id="element-336">
          <div className="space-y-2 md:space-y-4" data-id="element-337">
            <div className="inline-flex items-center gap-1.5 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full pt-[3px] pb-[3px] pl-[10px] pr-[10px]" data-id="element-338">
              <span className="text-sm md:text-base" data-id="element-339">✂️</span>
              <span className="text-[8.5px]" data-id="element-340">
                SISTEMA N°1 PARA BARBEROS EN LATINOAMÉRICA
              </span>
            </div>
            <h1 className="font-hero font-normal uppercase text-[40px] md:text-[80px] leading-[1.0] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-341">
              Tu silla llena
              <br data-id="element-342" />
              <span className="gold-metallic" data-id="element-343">en 48 horas.</span>
              <br data-id="element-344" />
              <span data-id="element-345">Sin ser influencer.</span>
            </h1>
            <p className="text-txt-body text-[14px] md:text-[18px] leading-[1.4] md:leading-[1.7] font-sans px-3 opacity-80" data-id="element-346">
              6 Niveles completos · Anuncios listos · Guiones de WhatsApp ·
              Sistema probado
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-347">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-348">
            <div className="absolute inset-0 bg-brandOrange/15 blur-[80px] rounded-full" data-id="element-349"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandBlue-electric/10 blur-[60px] rounded-full" data-id="element-350"></div>
            <img src="https://cdn.magicpatterns.com/uploads/sFEQjEmUsZK8vJ3cEmMSwK/mockup_principal_sticker.png" alt="MEGAPACK BARBERO PRO — Sistema completo para barberos" loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="relative block w-full max-w-[260px] md:max-w-[520px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-351" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-352">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-353">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-354">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-355">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-356">
                  📄
                </span>{' '}
                100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-357">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-358">
                  ⚡
                </span>{' '}
                Acceso en 5 min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-359">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-360">
                  📚
                </span>{' '}
                6 Niveles
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-361">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-362">
                  🎯
                </span>{' '}
                300 páginas
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-363">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-[18px]" data-id="element-364">
                💈 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-[13px] text-txt-muted font-sans" data-id="element-365">
                <span className="flex items-center gap-1" data-id="element-366">
                  Garantía 15 días
                </span>
                <span data-id="element-367">·</span>
                <span className="flex items-center gap-1" data-id="element-368">Pago seguro</span>
                <span data-id="element-369">·</span>
                <span className="flex items-center gap-1" data-id="element-370">Mercado Pago</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-371">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-372">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-373">
          <FadeIn delay={0.1} data-id="element-374">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-375">
              +500
            </div>
            <div className="text-sm font-sans text-txt-primary" data-id="element-376">
              barberos activos
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-377">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-378">
              6
            </div>
            <div className="text-sm font-sans text-txt-primary" data-id="element-379">
              Niveles listos
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-380">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-381">
              6
            </div>
            <div className="text-sm font-sans text-txt-primary" data-id="element-382">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-383">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-384">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-primary flex items-center justify-center gap-1" data-id="element-385">
              calificación{' '}
              <Star size={12} className="fill-brandOrange text-brandOrange" data-id="element-386" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MG',
    text: 'Llené el miércoles con $1 por día en ads. Ni lo podía creer.',
    author: 'Mati G., 27',
    role: 'Barbero · Palermo',
    bg: 'bg-brandOrange',
    badge: 'Megapack'
  }, {
    initials: 'NF',
    text: 'Copio el script de WhatsApp y el pibe agenda. Listo.',
    author: 'Nico F., 29',
    role: 'Barbero · La Plata',
    bg: 'bg-brandOrange',
    badge: 'Megapack + Pot.'
  }, {
    initials: 'TC',
    text: 'Primer mes facturé 40% más. Sin tocar precios.',
    author: 'Tomi C., 25',
    role: 'Barbero · Rosario',
    bg: 'bg-brandOrange',
    badge: 'Upselling'
  }];
  return <Section className="bg-bg-card" data-id="element-387">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-388">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-389">
            <div className="bg-bg-base p-3 md:p-3.5 rounded-[12px] border border-brandOrange/30 h-full flex flex-col" data-id="element-390">
              <div className="flex items-center gap-2 mb-2" data-id="element-391">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-black rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-[12px] shrink-0`} data-id="element-392">
                  {t.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-393">
                  <div className="flex items-center justify-between gap-1.5" data-id="element-394">
                    <p className="font-sans font-bold text-txt-primary text-[12.5px] md:text-[13px] leading-tight truncate" data-id="element-395">
                      {t.author}
                    </p>
                    <div className="flex text-brandOrange shrink-0" data-id="element-396">
                      {[...Array(5)].map((_, j) => <Star key={j} size={9} className="fill-current" data-id="element-397" />)}
                    </div>
                  </div>
                  <p className="text-[10.5px] md:text-[11px] font-sans text-txt-muted leading-tight mt-0.5" data-id="element-398">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-primary font-quote italic text-[13px] md:text-[13.5px] leading-[1.5] mb-2.5" data-id="element-399">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-400">
                <span className="inline-block bg-bg-highlight text-txt-muted font-sans font-bold uppercase tracking-[0.5px] text-[8.5px] md:text-[9px] px-1.5 py-0.5 rounded" data-id="element-401">
                  {t.badge}
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['El miércoles y el jueves la silla está fría y no sabés cómo llenarla', 'Invertiste en Meta Ads pero el botón "Promocionar" no te trajo ni un cliente real', 'Respondés WhatsApp a las 11 de la noche sin un guion claro y el cliente se enfría', 'Hacés Reels todos los días pero la agenda sigue con huecos', 'El cliente pregunta el precio y no sabés cómo responder para que no se vaya', 'Sabés que deberías cobrar más pero no tenés el sistema para justificarlo', 'Cada semana el mismo ciclo: publicar, esperar, nada, volver a publicar'];
  return <Section className="bg-bg-base" data-id="element-402">
      <div className="max-w-[720px] mx-auto" data-id="element-403">
        <FadeIn data-id="element-404">
          <h2 className="font-display font-extrabold uppercase md:text-[52px] text-center mb-8 text-txt-primary text-[32px]" data-id="element-405">
            Si sos <span className="text-brandOrange" data-id="element-406">barbero</span>,
            <br data-id="element-407" />
            esto te va a sonar{' '}
            <span className="text-brandOrange" data-id="element-408">familiar...</span>
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-409">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 md:gap-3 bg-bg-card border border-line rounded-[8px] py-1.5 px-2.5 md:py-3 md:px-4" data-id="element-410">
                <XCircle className="text-danger shrink-0 mt-0.5" size={13} data-id="element-411" />
                <p className="text-txt-primary font-sans text-[12px] md:text-[16px] leading-[1.35] md:leading-[1.5]" data-id="element-412">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Separator */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #C9A84C 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(201,168,76,0.8), 0 0 24px rgba(201,168,76,0.5)'
        }} data-id="element-413"></div>

          {/* Statement block */}
          <div className="bg-bg-card p-5 md:p-8 border-l-4 border-brandOrange mb-10" data-id="element-414">
            <p className="font-sans font-bold text-[16px] md:text-[19px] text-txt-primary mb-2" data-id="element-415">
              No es falta de <span className="text-brandOrange" data-id="element-416">talento</span>.
              <br data-id="element-417" />
              No es falta de <span className="text-brandOrange" data-id="element-418">esfuerzo</span>.
            </p>
            <p className="font-sans text-[14px] md:text-[16px] text-txt-primary opacity-80 leading-[1.6]" data-id="element-419">
              Es falta de un{' '}
              <span className="text-brandOrange font-bold" data-id="element-420">sistema</span> que
              lleve clientes del anuncio a la silla.
            </p>
          </div>

          <h3 className="font-display font-extrabold uppercase md:text-[40px] text-center text-brandOrange mb-6 relative text-[28px]" data-id="element-421">
            ¿Cuántos turnos más vas a dejar{' '}
            <span className="text-brandOrange inline-block" data-id="element-422">VACÍOS?</span>
          </h3>

          <div className="space-y-4 text-txt-primary opacity-80 font-sans text-[15px] md:text-[17px] leading-[1.7] mb-10 text-center" data-id="element-423">
            <p data-id="element-424">
              Elegiste este oficio porque sos bueno con la tijera y la máquina.
            </p>
            <p data-id="element-425">
              Pero nadie te enseñó a llenar la agenda. Nadie te dio los
              anuncios, los scripts de WhatsApp ni el sistema para convertir un
              clic en una cita confirmada.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border border-brandOrange/40 rounded-[14px] py-6 px-5 md:py-8 md:px-10 max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-426">
            <span aria-hidden="true" className="absolute -top-3 left-1/2 -translate-x-1/2 bg-bg-base px-3 font-display text-brandOrange text-[20px] leading-none" data-id="element-427">
              ✦
            </span>
            <p className="font-display uppercase tracking-[1px] text-[22px] md:text-[32px] leading-[1.15] text-txt-primary text-center" data-id="element-428">
              ¿Y si este fuera el{' '}
              <span className="text-brandOrange" data-id="element-429">último mes</span> que perdés
              plata por no tener el sistema?
            </p>
          </div>

          {/* Promise — barbero experto en marketing */}
          <div className="text-center max-w-2xl mx-auto" data-id="element-430">
            <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] text-brandOrange bg-brandOrange/10 border border-brandOrange/40 rounded-full px-3 py-1.5 mb-4" data-id="element-431">
              🎯 EL OBJETIVO
            </span>
            <p className="font-display uppercase tracking-[0.5px] text-[20px] md:text-[28px] leading-[1.2] text-txt-primary" data-id="element-432">
              Que te vuelvas un{' '}
              <span className="text-brandOrange" data-id="element-433">
                barbero experto en marketing
              </span>{' '}
              y <span className="text-brandOrange" data-id="element-434">diferente al resto.</span>
            </p>
            <p className="font-sans text-[13px] md:text-[15px] text-txt-primary opacity-70 leading-[1.5] mt-3" data-id="element-435">
              No otro barbero más en Instagram. Uno que entiende el negocio,
              llena la agenda y cobra lo que vale.
            </p>
          </div>
        </FadeIn>
      </div>
    </Section>;
};